<div class="card col-md-8">
  <div class="card-body">
    <form #form="ngForm" name="form" (ngSubmit)="submit()">
      <h5 class="card-title">Role </h5>
      <hr />
      <div class="row">
        <div class="col-md-4">
          <spk-text [name]="'Name'" [label]="'Name'" [autoComplete]="false" [(model)]="model.Name"></spk-text>
          <div class="form-group">
          </div>
        </div>
        <div class="col-md-4">
          <h5>Security Checkpoints</h5>
          <table class="table">
            <thead>
              <tr>
                <th>Name</th>
                <th>Description</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let checkpoint of model.Checkpoints">
                <td>{{checkpoint.CommandName}}</td>
                <td>{{checkpoint.Description}}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="col-md-4">
          <h5>Widgets</h5>
          <div *ngFor="let widget of widgets">
            <spk-checkbox name="widgetSelect{{widget.Value}}" [label]="widget.Text" [(model)]="widget.Selected"></spk-checkbox>
          </div>
        </div>
      </div>
    </form>
  </div>
</div> 
